import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isControls = location.pathname.startsWith('/controls');
  const isDashboard = location.pathname === '/dashboard' || location.pathname === '/';
  const isNotebook = location.pathname.startsWith('/notebook-ai');

  const navItems = [
    { label: 'Facility Map', icon: 'map', active: isDashboard, path: '/dashboard' },
    { label: 'Controls', icon: 'controls', active: isControls, path: '/controls/F9' },
    { label: 'Notebook AI', icon: 'notebook', active: isNotebook, path: '/notebook-ai' },
    { label: 'Dashboard', icon: 'dashboard' },
    { label: 'Rooms', icon: 'rooms' },
    { label: 'Alarms', icon: 'alarms', badge: 7 },
    { label: 'Events', icon: 'events' },
    { label: 'Calibrations', icon: 'calibrations' },
    { label: 'Reports', icon: 'reports' },
    { label: 'Schedules', icon: 'schedules' },
    { label: 'Settings', icon: 'settings' },
  ];

  return (
    <div className="sidebar-container">
      <div className="sidebar-logo">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#a3e635" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>
        <span>FLORAGUARD</span>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <div
            key={item.label}
            className={`nav-item ${item.active ? 'active' : ''}`}
            onClick={item.path ? () => navigate(item.path) : undefined}
            style={item.path ? { cursor: 'pointer' } : undefined}
          >
            <span className="nav-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
              </svg>
            </span>
            <span className="nav-label">{item.label}</span>
            {item.badge && <span className="nav-badge">{item.badge}</span>}
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <button className="collapse-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
          Collapse
        </button>

        <div className="system-status">
          <div className="status-header">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            System Status
          </div>
          <div className="status-value">
            All Systems Normal <span className="status-dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
